import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  canonical,
  ogType = 'website',
  ogImage = 'https://evolvelab.co/assets/img/banner-5/5.png',
  noindex = false,
}) => {
  const defaultTitle = 'EvolveLab - Startup Funding, Accelerator & Development for Canadian Founders';
  const defaultDescription = 'From seed to scale. We help founders develop, accelerate, and fund investor-ready businesses through structured clarity, accelerated execution, and capital alignment.';

  const siteUrl = 'https://evolvelab.co';
  const fullTitle = title ? `${title} | EvolveLab` : defaultTitle;
  const metaDescription = description || defaultDescription;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex,follow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
